// extracted by mini-css-extract-plugin
module.exports = {"classification-history-wrapper":"ClassificationHistoryTable_classification-history-wrapper__1NfBN"};